<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="10" :sm="12">
            <el-form-item label="日期范围:">
              <el-date-picker
                v-model="daterange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                class="ele-fluid"
                @change="onDateRangeChoose"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button
                @click="
                  (table.where = {
                    startTime: $util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'),
                    endTime: $util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'),
                  }) && $refs.table.reload()
                "
                >重置</el-button
              >
              <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column header-align="center" prop="keys" align="center" label="班级" />
          <el-table-column header-align="center" prop="values" align="center" label="请假人数" />
        </template>
      </ele-data-table>
    </el-card>
  </div>
</template>

<script>
  import { getLeaveReport } from '@/config/api';

  export default {
    name: 'LeaveReport',
    data() {
      return {
        table: {
          // 表格配置
          url: '/leaveReport/getAllLeaveInfo',
          where: {
            startTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'),
            endTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'),
          },
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [], // 表格选中数据
        daterange: [this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'), this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59')],
      };
    },
    methods: {
      /* 日期选择改变回调 */
      onDateRangeChoose() {
        if (this.daterange) {
          this.table.where.startTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd HH:mm:ss');
          this.table.where.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd HH:mm:ss');
        } else {
          this.table.where.startTime = null;
          this.table.where.endTime = null;
        }
      },
      // 导出数据
      exportData() {
        let data = {};
        if (this.daterange) {
          data.startTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd HH:mm:ss');
          data.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd HH:mm:ss');
        } else {
          data.startTime = this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00');
          data.endTime = this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59');
        }
        getLeaveReport(data).then((res) => {
          if (res.data.resCode == 200) {
            window.open(res.data.data);
          } else {
            this.$message({ type: 'info', message: '下载失败' });
          }
        });
      },
    },
  };
</script>

<style scoped></style>
